import { IoIosArrowDown } from 'react-icons/io';
import { RiUserSearchFill, RiPencilRulerLine } from 'react-icons/ri';
import {
  BsBarChartFill,
  BsCheckCircle,
  BsFillCalendarCheckFill,
} from 'react-icons/bs';
import { GiMoneyStack, GiHomeGarage } from 'react-icons/gi';
import { TbCircleNumber1 } from 'react-icons/tb';
import { TbCircleNumber2 } from 'react-icons/tb';
import { TbCircleNumber3 } from 'react-icons/tb';
import { TbCircleNumber4 } from 'react-icons/tb';
import { TbArrowBigRightFilled,
  TbArrowBigDownFilled, 
  TbPigMoney,
  TbSquareRoundedNumber1Filled, 
  TbSquareRoundedNumber2Filled, 
  TbSquareRoundedNumber3Filled, 
  TbSquareRoundedNumber4Filled } from 'react-icons/tb';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { HiClipboard, HiClipboardCheck } from 'react-icons/hi';
import { RiArrowDownSLine } from 'react-icons/ri';
import {
  FaUserAlt,
  FaShare,
  FaBed,
  FaBath,
  FaThList,
  FaMapMarked,
  FaMapMarkerAlt,
  FaSearchPlus
} from 'react-icons/fa';
import { BsFillTelephoneFill, BsSearch } from 'react-icons/bs';
import { FiMail } from 'react-icons/fi';
import { BsFillHouseAddFill, BsFillGridFill } from 'react-icons/bs';
import { BiBookOpen, BiErrorCircle, BiMap } from 'react-icons/bi';
import {
  AiOutlineShareAlt,
  AiFillPrinter,
  AiOutlinePlus,
  AiOutlineWhatsApp,
  AiFillPhone,
} from 'react-icons/ai';
import { AiTwotoneGold } from 'react-icons/ai';
import { GrClose } from 'react-icons/gr';
import {
  MdOutlineArrowDropDown,
  MdSimCardDownload,
  MdOutlineArrowBackIos,
  MdOutlineFilterList,
  MdOutlineFilterListOff,
  MdEmail,
  MdPhoneIphone
} from 'react-icons/md';
import { BsFacebook } from 'react-icons/bs';
import { BsInstagram } from 'react-icons/bs';
import { BsYoutube } from 'react-icons/bs';
import { MdViewList, MdArrowBackIos, MdArrowForwardIos  } from 'react-icons/md';
import { GoSearch } from 'react-icons/go';

export const iconsList = {
  IoIosArrowDown,
  RiUserSearchFill,
  BsBarChartFill,
  GiMoneyStack,
  TbPigMoney,
  TbArrowBigRightFilled,
  TbArrowBigDownFilled,
  TbSquareRoundedNumber1Filled,
  TbSquareRoundedNumber2Filled,
  TbSquareRoundedNumber3Filled,
  TbSquareRoundedNumber4Filled,
  FaUserAlt,
  BsFillTelephoneFill,
  FiMail,
  BsFillHouseAddFill,
  BiBookOpen,
  AiOutlineShareAlt,
  AiTwotoneGold,
  GrClose,
  MdOutlineArrowDropDown,
  BsFacebook,
  BsInstagram,
  BsYoutube,
  BsCheckCircle,
  BsSearch,
  FaShare,
  AiFillPrinter,
  RiPencilRulerLine,
  FaBed,
  FaBath,
  BsFillCalendarCheckFill,
  GiHomeGarage,
  BsFillGridFill,
  FaThList,
  FaMapMarked,
  FaMapMarkerAlt,
  IoIosArrowBack,
  IoIosArrowForward,
  HiClipboard,
  HiClipboardCheck,
  GoSearch,
  MdSimCardDownload,
  MdEmail,
  MdPhoneIphone,
  AiOutlinePlus,
  AiOutlineWhatsApp,
  AiFillPhone,
  BiErrorCircle,
  RiArrowDownSLine,
  MdOutlineFilterList,
  MdOutlineFilterListOff,
  BiMap,
  FaSearchPlus,
  MdArrowBackIos,
  MdArrowForwardIos 
};
